import {
  CSSProperties,
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

import { CSSTransition } from 'react-transition-group';

import { formError, formErrorText } from './styles.css';

export interface FormErrorProps {
  children?: ReactNode;
  error?: ReactNode;
  /**
   * 에러 메시지가 다른 요소들을 밀어내지 않고
   * `position: absolute`가 적용되도록 합니다.
   */
  isAbsolute?: boolean;
  style?: CSSProperties;
}

export interface FormErrorContextValue {
  error?: ReactNode;
}

export const FormErrorContext = createContext<FormErrorContextValue>({});

export const FormError = (props: FormErrorProps) => {
  const { children, error, isAbsolute, style } = props;
  const [savedError, setSavedError] = useState<ReactNode>('');
  const nodeRef = useRef(null);

  /**
   * 에러 메시지가 사라질 때
   * 애니메이션을 표현하기 위해 에러 메시지를 저장함
   */
  useEffect(() => {
    if (!error) return;
    setSavedError(error);
  }, [error]);

  return (
    <FormErrorContext.Provider value={{ error }}>
      {children}
      <CSSTransition nodeRef={nodeRef} in={!!error} timeout={250} unmountOnExit>
        <div ref={nodeRef} className={formError()}>
          <div className={formErrorText({ isAbsolute })} style={style}>
            {savedError}
          </div>
        </div>
      </CSSTransition>
    </FormErrorContext.Provider>
  );
};

export const useFormErrorContext = () => useContext(FormErrorContext);
